import { PropsWithChildren, useRef } from "react";

import { Flex } from "@radix-ui/themes";

import { useRemainingVerticalHeight } from "../../../hooks/useRemainingVerticalHeight";
import { ScrollArea } from "../ScrollArea";

type Props = PropsWithChildren;

export const DocumentContainer = ({ children }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  useRemainingVerticalHeight({
    ref,
    bottomGutterHeight: 32,
  });
  return (
    <ScrollArea
      ref={ref}
      style={{
        background: "var(--gray-11)",
      }}
    >
      <Flex direction="column" justify="center" align="center">
        {children}
      </Flex>
    </ScrollArea>
  );
};
